import React from 'react';
import { Contacts } from '@utils/constants/global';

export default (
  <>
    <p>Rove’s cancellation policy is as follows:</p>
    <ul>
      <li>
        <strong>48-Hour Grace Period:</strong> Reservations made at least 14
        days before the check-in date are fully refundable if canceled within 48
        hours of booking.
      </li>
      <li>
        <strong>60+ Days Before Check-In:</strong> Reservations canceled more
        than 60 days before check-in are eligible for a refund
      </li>
      <li>
        <strong>30-60 Days Before Check-In:</strong> Reservations canceled 30 to
        60 days before check-in are eligible for a credit toward a future Rove
        booking within the next 12 months.
      </li>
      <li>
        <strong>Less Than 30 Days Before Check-In:</strong> Reservations cannot
        be canceled within 30 days of the check-in date, and no refund or credit
        is available.
      </li>
      <li>
        <strong>Note:</strong> All applicable payment processing fees are
        non-refundable for cancellations.
      </li>
    </ul>
    <p>
      Please email{' '}
      <a href={`mailto:${Contacts.CONTACT_EMAIL}`}>{Contacts.CONTACT_EMAIL}</a>{' '}
      for any questions regarding cancellations.
    </p>
  </>
);
